var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcScheduleMeeting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 34,
    viewBox: "0 0 37 34",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "17.77%",
    x2: "100%",
    y2: "81.128%",
    id: "tm66rjf4ta"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C88FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FD8CC",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.04.386c3.868 0 6.44.626 8.66 1.813a12.26 12.26 0 0 1 5.1 5.1c1.188 2.221 1.814 4.793 1.814 8.66v2.081c0 3.868-.626 6.44-1.813 8.66a12.26 12.26 0 0 1-5.1 5.1c-2.221 1.188-4.793 1.814-8.66 1.814H15.96c-3.868 0-6.44-.626-8.66-1.813a12.26 12.26 0 0 1-5.1-5.1C1.011 24.48.385 21.907.385 18.04V15.96c0-3.868.626-6.44 1.813-8.66a12.26 12.26 0 0 1 5.1-5.1C9.52 1.011 12.093.385 15.96.385z",
    stroke: "url(#tm66rjf4ta)",
    strokeWidth: 0.773
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.655 12.311a2.907 2.907 0 0 1 1.353 2.16 2.346 2.346 0 1 0-1.353-2.16zm-1.537 4.805a2.347 2.347 0 1 0 0-4.694 2.347 2.347 0 0 0 0 4.694zm.995.16h-1.99a3.008 3.008 0 0 0-3.005 3.004v2.435l.006.038.168.053c1.58.494 2.954.659 4.085.659 2.208 0 3.488-.63 3.567-.67l.157-.08h.016V20.28a3.007 3.007 0 0 0-3.004-3.004zm3.883-2.423H22.02a2.892 2.892 0 0 1-.893 2.014 3.57 3.57 0 0 1 2.55 3.417v.75c1.951-.071 3.075-.624 3.15-.661l.156-.08H27v-2.436a3.008 3.008 0 0 0-3.004-3.004zM15 14.693c.46 0 .887-.134 1.248-.362a2.904 2.904 0 0 1 1.092-1.852c.002-.044.007-.087.007-.132A2.346 2.346 0 1 0 15 14.693zm2.108 2.174a2.894 2.894 0 0 1-.892-2.003c-.073-.005-.146-.01-.22-.01h-1.991A3.008 3.008 0 0 0 11 17.856v2.436l.006.037.168.053c1.268.396 2.4.579 3.383.636v-.735a3.57 3.57 0 0 1 2.55-3.417z",
    fill: "#5C88FF",
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcScheduleMeeting);
export default __webpack_public_path__ + "static/media/ic_schedule_meeting.ca79dc911be5021662afde1d62365200.svg";
export { ForwardRef as ReactComponent };